<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="true"
    :closable="true"
    :dismissable-mask="true"
    class="content-dialog"
  >
    <template #header>
      <div class="content-header">
        <h3>{{ $t('dialog.deleteappointment.title') }}</h3>
      </div>
    </template>
    <div class="confirmation-content">
      <span>{{ $t('dialog.deleteappointment.content') }}</span><br><br>
      <ul>
        <li>
          <p>
            {{ $t('entity.appointment.date') }} : <strong>{{ getAppointmentDay(appointment.start) }}, {{
              $t('entity.planning.from')
            }} {{ getAppointmentStartTime(appointment.start) }} {{ $t('entity.planning.to') }} {{
              getAppointmentEndTime(appointment.end)
            }}</strong>
          </p>
        </li>
        <li v-if="appointment.office">
          <p>
            {{ $t('entity.office.site') }} : <span class="font-bold">{{ appointment.office.site.name }}</span>
          </p>
          <p>
            {{ $t('entity.site.address.field') }} :
            <strong>
              {{ appointment.office.site.address.name }}, {{ appointment.office.site.address.postcode }} {{ appointment.office.site.address.city }}
            </strong>
          </p>
          <p>{{ $t('entity.appointment.office') }} : <span class="font-bold">{{ appointment.office.name }}</span></p>
        </li>
        <li v-else>
          <p>
            {{ $t('entity.appointment.roamingTeam') }} : <span class="font-bold">{{ appointment.roamingTeam.name }}</span>
          </p>
          <p>
            {{ $t('entity.site.address.field') }} :
            <strong>
              {{ appointment.wishedMeetingAddress.name }}, {{ appointment.wishedMeetingAddress.postcode }} {{ appointment.wishedMeetingAddress.city }}
            </strong>
          </p>
        </li>
      </ul>
    </div>
    <template #footer>
      <Button
        :label="$t('action.cancel')"
        icon="pi pi-times"
        class="p-button-rounded p-button-outlined p-button-secondary"
        @click="closeModaleDelete"
      />
      <Button
        :label="$t('action.confirm')"
        icon="pi pi-check"
        class="p-button-rounded p-button-outlined"
        @click="cancelAppointment"
      />
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import {convertDateStringToDayLocaleString, convertDateStringToTimeLocaleString} from "@/shared/utils/dateTimeUtils";
import moment from "moment";
import useAppointmentStatus from "@/composables/useAppointmentStatus";

export default {
  name: 'AppointmentCancelDialog',
  components: { Dialog, Button },
  props: {
    appointment: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
    }
  },
  emits: ['update:visible', 'cancel'],
  setup(){
    const appointmentStatus = useAppointmentStatus();

    return {
      appointmentStatus
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    async cancelAppointment() {
      try {
        await this.$appointmentService.changeStatus(this.appointment.id, this.appointmentStatus.CANCELED)
        this.$emitter.emit('toast', { severity: 'success', message: 'dialog.deleteappointment.toast.delete' })
        this.$emit('update:visible', false)
        this.$emit('cancel')
      } catch (e) {
        const errors = e.response.data.map(error => this.$t(error)).join(', ')
        this.$emitter.emit('toast', { severity: 'error', message: errors })
      }
    },
    closeModaleDelete() {
      this.$emit('update:visible', false)
    },
    getAppointmentDay(dateString) {
      return convertDateStringToDayLocaleString(dateString, this.$i18n.locale)
    },
    getAppointmentStartTime(dateString) {
      return convertDateStringToTimeLocaleString(dateString, this.$i18n.locale)
    },
    getAppointmentEndTime(dateString) {
      const end = moment(dateString, 'HH:mm:ss').toDate()
      return convertDateStringToTimeLocaleString(end, this.$i18n.locale)
    },
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  padding: 0;

  li: {
    list-style: none;
    margin: 5px 0px;
  }
}

.content-dialog {
  max-height: 350px;
  max-width: 250px;
}

.content-header {
  padding: 0px;
}
</style>
